import { render } from "./DatepickerFoldout.vue?vue&type=template&id=17047940"
import script from "./DatepickerFoldout.vue?vue&type=script&lang=js"
export * from "./DatepickerFoldout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__